import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { NotificationManager } from 'react-notifications';
import { isPasswordValid } from '../../authentication';
import { makeValidable } from '@ami/react/core';
import { Button } from '@ami/react/core';
import { dealerUserService } from '../../dealer-users/dealerUserService';

const FormData = makeValidable(
  ({ password, confirmPassword, updatePassword, onSubmit, refForm }) => {
    return (
      <form className="container" onSubmit={onSubmit} ref={refForm}>
        <div className="row">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <FormInput
                  label="New Password"
                  name="password"
                  value={password}
                  onChange={(e) => updatePassword(e)}
                  required
                  type="password"
                />
              </div>
              <div className="col-md-6">
                <FormInput
                  label="Confirm Password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => updatePassword(e)}
                  required
                  type="password"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
);

export default class DealerUserChangePasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.validate = this.validate.bind(this);
  }

  state = {
    show: false,
    password: '',
    confirmPassword: '',
    showValidations: false,
    changing: false,
  };

  static propTypes = {
    userId: PropTypes.string.isRequired,
  };

  open() {
    this.setState({
      show: true,
      password: '',
      confirmPassword: '',
      showValidations: false,
    });
  }

  hide = () => this.setState({ show: false });

  updatePassword = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();
    if (this.validate() && this.validateForm()) {
      this.setState({ changing: true });
      dealerUserService
        .changePassword({
          userId: this.props.userId,
          password: this.state.password,
        })
        .then(() =>
          NotificationManager.success(
            'Password changed successfully',
            '',
            3 * 1000
          )
        )
        .catch(() => console.log('An error ocurred resetting the password'))
        .finally(() => this.setState({ changing: false, show: false }));
    }
  };

  validate() {
    this.setState({ showValidations: true });
    return this.form.current.reportValidity();
  }

  validateForm() {
    if (!isPasswordValid(this.state.password)) {
      NotificationManager.error('Password must be at least 8 characters');
      return false;
    }
    if (this.state.password !== this.state.confirmPassword) {
      NotificationManager.error('Passwords do not match!');
      return false;
    }
    return true;
  }

  render() {
    if (!this.state.show) return null;

    const { password, confirmPassword, showValidations, changing } = this.state;

    return (
      <SimpleModal show={this.state.show} size="lg">
        <ModalHeader title={'Reset Dealer Password'} />
        <ModalBody>
          <FormData
            password={password}
            confirmPassword={confirmPassword}
            updatePassword={this.updatePassword}
            onSubmit={this.onSubmit}
            refForm={this.form}
            showValidations={showValidations}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            label="Cancel"
            onClick={this.hide}
            className="btn-secondary"
          />
          <Button
            label={changing ? 'Changing...' : 'Change'}
            onClick={this.onSubmit}
            className="btn-primary"
            showSpinner={changing}
            disabled={changing}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
